import React from 'react';
import { Link } from 'gatsby';
import Slider from 'react-slick';
import CarouselNextArrow from '../CarouselNextArrow/CarouselNextArrow';
import CarouselPrevArrow from '../CarouselPrevArrow/CarouselPrevArrow';
import './Articles.scss';

const Articles = () => {
  const sliderRef = React.createRef();

  const settings = {
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    nextArrow: <CarouselNextArrow />,
    prevArrow: <CarouselPrevArrow />,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          nextArrow: false,
          prevArrow: false,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          nextArrow: false,
          prevArrow: false,
        },
      },
    ],
  };

  return (
    <div className="articles container">
      <div className="flex justify-space-between align-center">
        <h1 className="heading">Posts from Aerotime</h1>
      </div>
      <div className="articleBox">
        <Slider {...settings} ref={sliderRef}>
          <Link to="/" className="article">
            <img
              className="image"
              src="https://images.unsplash.com/photo-1593642532400-2682810df593?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2938&q=80"
              alt=""
            />
            <p className="title">
              How to overcome the fear of starting something new
            </p>
          </Link>
          <Link to="/" className="article">
            <img
              className="image"
              src="https://images.unsplash.com/photo-1593642532400-2682810df593?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2938&q=80"
              alt=""
            />
            <p className="title">
              How to overcome the fear of starting something new
            </p>
          </Link>
          <Link to="/" className="article">
            <img
              className="image"
              src="https://images.unsplash.com/photo-1593642532400-2682810df593?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2938&q=80"
              alt=""
            />
            <p className="title">
              How to overcome the fear of starting something new
            </p>
          </Link>
          <Link to="/" className="article">
            <img
              className="image"
              src="https://images.unsplash.com/photo-1593642532400-2682810df593?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2938&q=80"
              alt=""
            />
            <p className="title">
              How to overcome the fear of starting something new
            </p>
          </Link>
          <Link to="/" className="article">
            <img
              className="image"
              src="https://images.unsplash.com/photo-1593642532400-2682810df593?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2938&q=80"
              alt=""
            />
            <p className="title">
              How to overcome the fear of starting something new
            </p>
          </Link>
        </Slider>
      </div>
    </div>
  );
};

export default Articles;
